import { getMethod } from "../../../modules/helper";

const getCity = id => {
  return new Promise(async reject => {
    const response = await getMethod("/address/v1/city/all/" + id);

    if (response && response.status === 200)
      reject(response.data.result.cities);
  });
};

export default getCity;
